import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_slice_images } from '@/hooks/store/use_slices';
import { REMOTE__images_load_by_hash_content } from '@/state/images/load/REMOTE__images_load_by_hash_content';
import { assert_hash_sha256_not_empty } from '@shared/asserts/utils_asserts';
import { throttle } from 'es-toolkit';
import { useRef } from 'react';

export function WATCHER_IMAGES__load() {
  /*
   * STORE
   */

  const dispatch = use_dispatch();

  const { images_hashes_loading } = use_slice_images(['images_hashes_loading']);

  const try_load_images_by_hash_throttle = throttle(try_load_images_by_hash, CONSTANTS_TIME__client.THROTTLE_IMAGE_LOADING, {
    leading: true,
    trailing: true,
  });

  const ref_is_loading = useRef(false);

  use_effect(() => {
    void try_load_images_by_hash_throttle();
  }, [images_hashes_loading]);

  async function try_load_images_by_hash() {
    if (images_hashes_loading.size == 0) return;
    if (ref_is_loading.current) return;

    ref_is_loading.current = true;

    let images_hashes_to_load = Array.from(images_hashes_loading);

    for (let hash of images_hashes_to_load) assert_hash_sha256_not_empty(hash);

    await dispatch(REMOTE__images_load_by_hash_content(images_hashes_to_load));

    ref_is_loading.current = false;
  }

  return null;
}
